import React from "react";
import "./styles.css";
import { Loading } from "../Loader";
import { Button } from "../Button";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import language from "../../language";
import { clearStorage, getStorage, setStorage } from "../../utils/storage";
import { connect } from "react-redux";
import logoImage from "../../assets/logo.png";
import { fetchMerchantVerifications } from "../../queries/verification/merchantVerficationQuery";
import { saveProfileUnits } from "../../actions/ProfileUnits";
import { fetchMerchantID } from "../../queries/merchantID/merchantIDQuery";
import api from "../../utils/api";

class SSOAuth extends React.Component {
  state = {
    isLoading: true,
  };

  UNSAFE_componentWillMount() {
    const { redirectToken } = this.props;

    this.setState({ redirectToken });

    if (redirectToken && redirectToken !== "") {
      this.handleSSO(redirectToken);
    }
  }

  handleSSO(redirectToken) {
    this.setState({ isLoading: true });

    let formData = new URLSearchParams();
    formData.append("grant_type", "urn:ietf:params:oauth:grant-type:sso_token");
    formData.append("scope", "* openid");
    formData.append("token", redirectToken);

    var username = process.env.REACT_APP_SSO_USERNAME;
    var password = process.env.REACT_APP_SSO_PASSWORD;

    var basicAuth = "Basic " + btoa(username + ":" + password);

    const options = {
      url: `${api("sso")}/oauth2/token`,
      method: "POST",
      data: formData,
      headers: {
        Authorization: basicAuth,
      },
    };

    axios(options)
      .then((data) => {
        if (data.data && data.data.access_token) {
          this.fetchUserProfile(data.data);

          return;
        }

        this.setState({ isLoading: false, redirectToken: null });
        toastMessage("error", "Authentication failed");
      })
      .catch((error) => {
        console.log(error);
        this.setState({ isLoading: false, redirectToken: null });
        toastMessage(
          "error",
          error?.response?.statusText || "Authentication failed"
        );
      });
  }

  fetchUserProfile(tokenInfo) {
    const { access_token } = tokenInfo;

    const options = {
      method: "GET",
      url: `${api("sso")}/profile/${tokenInfo.profilePublicId}`,
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    };

    axios(options)
      .then((data) => {
        this.onSuccess({ ...data.data, accessToken: access_token });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ isSubmitting: false });

        toastMessage(
          "error",
          language[this.props.defaultLanguage].unauthorized
        );
      });
  }

  handleGetProfileUnits = async (tokenInfo) => {
    const { accessToken } = tokenInfo;

    let headers = {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${accessToken}`,
    };

    const options = {
      method: "GET",
      url: `${api("profile")}/profile/units`,
      data: null,
      headers,
    };

    return await axios(options)
      .then((data) => {
        return data.data;
      })
      .catch((error) => {
        console.log("query profile units error: ", error);

        toastMessage("error", error);

        return language[this.props.defaultLanguage]
          .unable_fetch_organization_units;
      });
  };

  handleGetBusinessCategory = async (tokenInfo) => {
    const { accessToken } = tokenInfo;

    let headers = {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${accessToken}`,
    };

    const options = {
      method: "GET",
      url: `${api("profile")}/organisation/business/category`,
      data: null,
      headers,
    };

    return await axios(options)
      .then((data) => {
        return data.data;
      })
      .catch((error) => {
        console.log(error);

        toastMessage("error", error);

        return language[this.props.defaultLanguage]
          .unable_fetch_organization_units;
      });
  };

  onSuccess = async (profile) => {
    console.log("===================profile token=================");
    console.log(profile);
    console.log("====================================");
    try {
      if (!profile.accessToken) {
        this.setState({ isSubmitting: false });
        toastMessage("error", "Unauthorized access token");
        return;
      }

      await setStorage(profile);

      const organizationBusinessCategory = await this.handleGetBusinessCategory(
        profile
      );

      let profileData = {
        ...profile,
      };

      //get profile units
      const profileUnits = await this.handleGetProfileUnits(profile);
      //save profile units data
      await this.props.dispatch(saveProfileUnits(profileUnits));

      //update storage with organization business category information
      if (Object.keys(organizationBusinessCategory || {})?.length > 0) {
        profileData["businessCategoryId"] =
          organizationBusinessCategory.businessCategoryId;
        profileData["businessCategory"] = organizationBusinessCategory.name;
        profileData["countryId"] = organizationBusinessCategory.countryId;
      }

      let userInfo = await getStorage();

      //fetch merchant ID
      const merchantID = await fetchMerchantID(this.props.defaultLanguage);

      if (merchantID?.identifier) {
        //save merchant ID
        await setStorage({ merchantID: merchantID.identifier }, "merchantID");

        userInfo.merchantID = merchantID.identifier;
        // await setStorage(userInfo);
      }

      userInfo = {
        ...userInfo,
        ...profileData,
      };

      await setStorage(userInfo);

      if (
        profileUnits.length === 0 ||
        !organizationBusinessCategory ||
        !organizationBusinessCategory?.businessCategoryId ||
        !organizationBusinessCategory?.countryId
      ) {
        this.setState({ isLoading: false });

        return (window.location.href = "/merchant/kyc/onboarding/initial");
      }

      let countMyUnits = 0;

      profileUnits.forEach((unit) => {
        if (unit.provided && unit.approved) {
          countMyUnits += 1;
        }
      });

      //check verifications
      const verifications = await fetchMerchantVerifications(
        this.props.defaultLanguage
      );

      let isAccountApproved = false,
        isKYCVerified = false;

      verifications.forEach((el) => {
        if (el.verificationType === "ACCOUNT_APPROVAL") {
          isAccountApproved = true;
        }

        if (el.verificationType === "KYC_DOCUMENT_VERIFICATION") {
          isKYCVerified = true;
        }
      });

      if (isAccountApproved) {
        this.setState({ isLoading: false });

        let storageProfile = await getStorage();

        userInfo.verified = isKYCVerified;
        await setStorage(userInfo);
        return (window.location.href = "/merchant/analytics");
      }

      this.setState({ isLoading: false });

      window.location.href = "/merchant/kyc/onboarding/stepTwo";
    } catch (error) {
      console.log("Authentication sso error:", error);
      toastMessage("error", error);

      this.resetAuth();
    }
  };

  resetAuth = async () => {
    await clearStorage();

    this.setState({
      redirectToken: undefined,
      isLoading: false,
    });
  };

  render() {
    return (
      <div className="sso-container">
        {!this.state.redirectToken ? (
          <center className="col-md-4">
            <div className="sso-logo-container">
              <img src={logoImage} />
            </div>
            <h2 className="mb-3">Welcome to Merchant Portal</h2>
            <Button
              styles={{ width: 100 }}
              text="Login"
              onPress={() =>
                (window.location.href =
                  process.env.REACT_APP_NODE_ENV === "development"
                    ? "https://accounts.development.mobitill.com/auth/signin"
                    : process.env.REACT_APP_NODE_ENV === "uat"
                    ? "https://accounts.uat.mobitill.com/auth/signin"
                    : "https://accounts.development.mobitill.com/auth/signin")
              }
            />
          </center>
        ) : (
          this.state.isLoading && <Loading size="lg" />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(SSOAuth);
